namespace BlockPuzzle {
    export enum LayoutType {
        PORTRAIT = 0,
        SQUARED = 1,
        LANDSCAPE = 2
    }
}